// extracted by mini-css-extract-plugin
export default {"individualPlayer":"IndividualPlayer_individualPlayer__sDKUg"};